export const QUOTE_DOCUMENT_TYPES = Object.freeze({
  CLIENT_QUOTE: 'client_quote',
  MINUTE: 'minute',
  CALCULATION_DETAIL: 'calculation_detail',
  ATTACHMENT: 'attachment',
});

export const QUOTE_DOCUMENT_LABELS = Object.freeze({
  [QUOTE_DOCUMENT_TYPES.CLIENT_QUOTE]: 'Devis client',
  [QUOTE_DOCUMENT_TYPES.MINUTE]: 'Minute de chiffrage',
  [QUOTE_DOCUMENT_TYPES.CALCULATION_DETAIL]: 'Méthodes de calcul',
  [QUOTE_DOCUMENT_TYPES.ATTACHMENT]: 'Pièce associée',
});

const value = (source, ...keys) => {
  for (const key of keys) {
    if (source?.[key] !== undefined && source?.[key] !== null && source?.[key] !== '') {
      return source[key];
    }
  }
  return null;
};

export const quoteDocumentLabel = (type) => QUOTE_DOCUMENT_LABELS[type] || type || 'Document';

export const quoteDocumentIsOfficial = (document) => Boolean(
  document?.isCurrent
  ?? document?.isOfficial
  ?? document?.official
);

export const quoteDocumentGedPath = (document) => value(
  document,
  'gedPath',
  'ged_path',
  'nextcloudPath',
  'nextCloudPath',
  'archivePath',
  'archive_path'
);

export const quoteDocumentIsArchived = (document) => Boolean(
  value(document, 'archivedInGed', 'archived_in_ged', 'gedArchivedAt', 'ged_archived_at')
  || quoteDocumentGedPath(document)
);

export const canViewQuoteDocument = (document, permissions = {}) => {
  const type = document?.documentType;
  if (type === QUOTE_DOCUMENT_TYPES.MINUTE) return Boolean(permissions.canViewMinute);
  if (type === QUOTE_DOCUMENT_TYPES.CALCULATION_DETAIL) return Boolean(permissions.canViewCosts);
  return true;
};

export const availableQuoteDocumentTypes = (permissions = {}) => [
  QUOTE_DOCUMENT_TYPES.CLIENT_QUOTE,
  ...(permissions.canViewMinute ? [QUOTE_DOCUMENT_TYPES.MINUTE] : []),
  ...(permissions.canViewCosts ? [QUOTE_DOCUMENT_TYPES.CALCULATION_DETAIL] : []),
];

export const sortQuoteDocuments = (documents = []) => [...documents].sort((a, b) => {
  const officialDelta = Number(quoteDocumentIsOfficial(b)) - Number(quoteDocumentIsOfficial(a));
  if (officialDelta) return officialDelta;
  const bDate = new Date(b.generatedAt || b.createdAt || 0).getTime();
  const aDate = new Date(a.generatedAt || a.createdAt || 0).getTime();
  return bDate - aDate;
});

export const buildQuoteGedArchiveRequest = (editor, document) => ({
  quote_id: editor?.id,
  quote_version_id: editor?.quoteVersionId,
  document_id: document?.id,
  project_id: editor?.projectId || null,
  affair_id: editor?.affairId || null,
  document_type: document?.documentType || QUOTE_DOCUMENT_TYPES.CLIENT_QUOTE,
});

export const formatDocumentSize = (size) => {
  const bytes = Number(size || 0);
  if (!Number.isFinite(bytes) || bytes <= 0) return '-';
  if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
};
